export const locales = {
	menuBtnLabel: (action: string): string => `${action} le menu`,
	open: 'Ouvrir',
	close: 'Fermer',
	menu: 'Menu'
};
